/** ต้องตรงกับ SitePublicAmenityCatalog ฝั่ง API + Admin (icon = Material Symbols Outlined) */
export const SITE_AMENITY_META: Record<string, { icon: string; th: string; en: string }> = {
  ev_charger: { icon: 'ev_station', th: 'EV Charger', en: 'EV Charger' },
  security_guard: { icon: 'local_police', th: 'รปภ.', en: 'Security guard' },
  cctv: { icon: 'videocam', th: 'กล้องวงจรปิด', en: 'CCTV' },
  staff: { icon: 'support_agent', th: 'มีเจ้าหน้าที่ดูแล', en: 'On-site staff' },
  monthly_pass: { icon: 'card_membership', th: 'บัตรรายเดือน', en: 'Monthly pass' },
  open_24h: { icon: 'schedule', th: 'เปิด 24 ชม.', en: 'Open 24 hours' },
  covered: { icon: 'roofing', th: 'จอดในร่ม', en: 'Covered parking' },
  motorcycle: { icon: 'two_wheeler', th: 'ที่จอดมอเตอร์ไซค์', en: 'Motorcycle parking' },
  accessible: { icon: 'accessible', th: 'ที่จอดผู้พิการ', en: 'Accessible parking' },
  lady_parking: { icon: 'woman', th: 'ที่จอดสุภาพสตรี', en: 'Ladies parking' },
  lighting: { icon: 'lightbulb', th: 'แสงสว่างเพียงพอ', en: 'Well lit' },
  cashless: { icon: 'qr_code_2', th: 'จ่ายแบบไม่ใช้เงินสด', en: 'Cashless payment' },
  restroom: { icon: 'wc', th: 'ห้องน้ำ', en: 'Restroom' },
  near_transit: { icon: 'train', th: 'ใกล้รถไฟฟ้า', en: 'Near BTS/MRT' },
};

export const SITE_IMAGE_CATEGORY_LABELS: Record<string, { th: string; en: string }> = {
  parking: { th: 'ลานจอด', en: 'Parking' },
  surrounding: { th: 'บริเวณรอบลาน', en: 'Surroundings' },
  entrance: { th: 'ทางเข้า-ออก', en: 'Entrance' },
  facility: { th: 'สิ่งอำนวยความสะดวก', en: 'Facilities' },
};

export function isKnownAmenity(code: string | null | undefined): boolean {
  return !!code && !!SITE_AMENITY_META[code.toLowerCase()];
}
